exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Fonts (Typekit Kit ID: rgi7wxl)\n * =============================================================================\n */\n\n/* Calder */\n\n.calderLC--1nri- {\n  font-family: \"calder-lc\", sans-serif;\n}\n\n.calderDark--1bp9m {\n  font-family: \"calder-dark\", sans-serif;\n}\n\n.calderDarkOutline--2da16 {\n  font-family: \"calder-dark-outline\", sans-serif;\n}\n", ""]);

// exports
exports.locals = {
	"calderLC": "calderLC--1nri-",
	"calderDark": "calderDark--1bp9m",
	"calderDarkOutline": "calderDarkOutline--2da16"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--1-1!../node_modules/postcss-loader/lib??postcss!./shared/css/fonts.css
// module id = 391
// module chunks = 2